<template>
  <div>
    <div>
      <aha-modal @hide="hide()" :title="title">
        <div>
          {{ bodyTextContent }}
        </div>

        <template #action>
          <aha-antd-button
            v-aha-emit-action
            name="move-presentation-warning-cancel"
            variant="secondary"
            class="mr-2"
            @click="hide()"
          >
            <span>{{ $i18nPresenter.t("Cancel") }}</span>
          </aha-antd-button>
          <aha-antd-button
            v-aha-emit-action
            name="move-presentation-warning-move"
            is-loading-inline
            @click="movePresentations()"
          >
            {{ $i18nPresenter.t("Move") }}
          </aha-antd-button>
        </template>
      </aha-modal>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import moveFolderMixin from '@/mixins/folder/move-folderMixin'

export default {
  name: 'ModalWarning',
  mixins: [moveFolderMixin],
  props: {
    title: {
      type: String,
      default: '',
    },
  },
  computed: {
    ...mapState({
      currentFolder: (state) => state.currentFolder,
    }),
    ...mapGetters('movePresentation', ['destinationFolder']),
    bodyTextContent() {
      if (!this.currentFolder?.hasShared && this.destinationFolder.hasShared) {
        return this.$i18nPresenter.t('This item will be visible to everyone who can see ‘{folderName}’.', {
          folderName: this.destinationFolderName,
        })
      }
      if (this.currentFolder?.hasShared && !this.destinationFolder.hasShared) {
        return this.$i18nPresenter.t('Everyone who can see ‘{folderName}’ will lose access to this item unless this item is shared directly with them.', {
          folderName: this.currentFolderName,
        })
      }
      return this.$i18nPresenter.t('This item will be visible to everyone who can see ‘{destinationFolderName}’. Everyone who can see ‘{currentFolderName}’ will lose access to this item unless this item is shared directly with them.', {
        destinationFolderName: this.destinationFolderName,
        currentFolderName: this.currentFolderName,
      })
    },
  },
  methods: {
    hide() {
      this.$emit('hide')
    },
  },
}
</script>
